import React, { useEffect, useState } from "react";
import { Input, Table, Tooltip } from "antd";

import { useAppSelector } from "../../../store/hooks";

import DeleteModal from "../../../components/Modals/DeleteModal";

import { firstLetterCap } from "../../../utils";
import { getNotification } from "../../../store/services/notification";
import CreateNotification from "../../../components/Modals/CreateNotification";
import { NotificationGroupType } from "../../../store/interfaces/Notification";

const { Search } = Input;

const NotificationPage: React.FC = () => {
  const { loading, notificationsGroup } = useAppSelector((state) => state.notificationsSettings);
  const [page, setPage] = useState<number>(1);
  const [perPage] = useState<number>(10);
  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
    // eslint-disable-next-line
  }, [page]);

  const getData = async () => {
    const payload = {
        page: page,
        limit: perPage
    }
    await getNotification(payload);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (t: string) => <p>{firstLetterCap(t)}</p>,
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      render: (t: string, obj: NotificationGroupType) => (
        <p>{firstLetterCap(obj?.message) || "-"}</p>
      ),
    },
    {
        title: "Label Name",
        dataIndex: "labelId",
        key: "labelId",
        render: (t: string, obj: NotificationGroupType) => (
          <p>{firstLetterCap(obj?.labelId?.name) || "-"}</p>
        ),
    },
    {
      title: "Users",
      dataIndex: "users",
      key: "users",
      render: (_: string, obj: NotificationGroupType) => {
        const displayUsers = obj?.users.slice(0, 2);
        const otherUsers = obj?.users.slice(2);

        return (
          <Tooltip
            placement="top"
            title={otherUsers?.map((v) => `${v?.email}`).join(", ")}
          >
            <>
              {displayUsers?.map((v, index) => (
                <span key={index}>
                  {v?.email}
                  {index < displayUsers?.length - 1 && ", "}
                </span>
              ))}
              {otherUsers?.length > 0 && (
                <span>
                  <strong>, and {otherUsers?.length} more...</strong>
                </span>
              )}
              {!!obj?.users && <span>-</span>}
            </>
          </Tooltip>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (t: string) => (
        <p>{t ? firstLetterCap(t) : "-"}</p>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_: string, obj: NotificationGroupType) => (
        <div className="icon_box">
          <DeleteModal type={"notifications"} id={obj?._id} getData={getData} />
        </div>
      ),
    },
  ];

  const filteredSchedules = notificationsGroup?.filter((v) =>
    v?.title?.toLowerCase()?.includes(search?.toLowerCase())
  );

  return (
    <div className="user_container">
      <header>
        <h1>Notifications</h1>
        <div>
          <CreateNotification getData={getData} />
        </div>
      </header>

      <div className="search_input_box">
        <Search
          placeholder="Search by name..."
          enterButton
          allowClear
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="user_table_container category_table">
        <Table
          loading={loading}
          columns={columns}
          dataSource={filteredSchedules}
          rowKey={(record) => record._id}
          scroll={{ x: 1100 }}
          pagination={{
            current: page,
            total: notificationsGroup?.length,
            pageSize: perPage,
            onChange: (val) => {
              setPage(val);
            },
          }}
        />
      </div>
    </div>
  );
};

export default NotificationPage;
